import { useEffect, useRef, useState } from "react";
import {
  handleFirstImage,
  handleNavigate,
  updateIsEmptyStatus,
} from "../../../../Utils/StayUpToDate/RenderComponent";
import { StayFeedLoadingPlaceholder } from "../../../../Screens/DashboardView/MasterTemplateEditor/WebsiteLibFeedSkeleton";
import { useParams } from "react-router-dom";
import { debounce } from "lodash";
import { StaticVariables } from "../../../../Utils/StaticVariables";
import FrontendTemplate from "../StructureTemplates/FrontendTemplate";
import PostTemplate from "../CommonComponents/PostTemplate";
import { useLoadQueryFeed } from "../../../../Screens/DashboardView/LandingPageCarousels/QueryBasedCarousel/useLoadQueryFeed";
import { useMemo } from "react";
import {
  deriveAllowedPlatforms,
  filterOutProductCatalogPosts,
  readPlatformFilterFromDetails,
  resolveShowFilterFromComponent,
  shouldUseShopKeywordRpc,
  ShowFilter,
} from "../../../../Screens/DashboardView/LandingPageCarousels/QueryBasedCarousel/filterUtils";
import { FeedSectionEmptyState } from "../FeedSectionEmptyState";
import { websiteEditorFeedEmptyMessage } from "../../../../Screens/DashboardView/MasterTemplateEditor/websiteEditorFeedEmptyMessage";
import { tagProductFeedAsProductType } from "../../../../Utils/productImage/productImageDisplay";


const QueryLinkDataFront = (props: any) => {
  const itemsPerPage = 3;
  const {
    user_id,
    username,
    title,
    postIds,
    handleRedirect,
    brand_color,
    isLinks,
    component,
    type,
    query,
    removedPostIds,
    RenderUI,
    from,
    
    templateGridLoaderProps,designTokens,
    onFeedResolved,
    showEmptyInEditor = false,
  } = props;

  const param = useParams();
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef<any>(null);
  const isButtonClicked = useRef(false);
  const [isLoading, setIsLoading] = useState(true);
  const platformFilter = readPlatformFilterFromDetails(component?.details);
  const showFilter = resolveShowFilterFromComponent(
    component?.shoppable_content_filter,
    "products"
  );
  const isShopRpc = shouldUseShopKeywordRpc(
    component?.type || type,
    component?.shoppable_content_filter,
  );
  const showSocials = deriveAllowedPlatforms(
    platformFilter,
    showFilter,
    isShopRpc
  );
  const contentOrder = StaticVariables().DEFAULT_CONTENT_ORDER;

  const {
    isLoading: queryFeedLoading,
    data: queryFeedPages,
    total_count,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
  }: any = useLoadQueryFeed(
    username,
    user_id,
    query,
    showSocials,
    contentOrder,
    isShopRpc,
    removedPostIds,
    title,
    component?.content_order,
    component?.custom_order?.split(","),
    showFilter
  );

  const flattenedAll = useMemo(() => {
    if (!queryFeedPages || !Array.isArray(queryFeedPages)) return [];
    return filterOutProductCatalogPosts(
      queryFeedPages.flatMap((page: any) => page?.data || []),
      isShopRpc,
    );
  }, [queryFeedPages, isShopRpc]);

  const shoppableFilteredAll = useMemo(() => {
    const status = String(component?.shoppable_status_filter || "all")
      .toLowerCase()
      .trim();
    const filtered =
      status === "all"
        ? flattenedAll
        : flattenedAll.filter((post: any) => {
            const link =
              typeof post?.shop_link === "string"
                ? post.shop_link.trim()
                : typeof post?.shopLink === "string"
                  ? post.shopLink.trim()
                  : typeof post?.shop_url === "string"
                    ? post.shop_url.trim()
                    : "";
            const shoppable =
              post?.is_shoppable === true ||
              post?.isShoppable === true ||
              Boolean(link);
            return status === "shoppable" ? shoppable : !shoppable;
          });
    if (!isShopRpc) return filtered;
    // Match Custom Products / trending products: ProductBank white-frame CSS.
    return tagProductFeedAsProductType(filtered, component?.type || type);
  }, [flattenedAll, component?.shoppable_status_filter, component?.type, type, isShopRpc]);

  // Flatten pages and limit to 25 items (matching MaxCount behavior) — PostTemplate / carousel only
  const queryFeed = useMemo(() => {
    return {
      resultArray: shoppableFilteredAll.slice(0, 25),
      total_count: total_count || 0,
    };
  }, [shoppableFilteredAll, total_count]);

  useEffect(() => {
    if (queryFeedLoading) setIsLoading(true);
  }, [queryFeedLoading]);

  useEffect(() => {
    if (from !== "website-template" || !onFeedResolved) return;
    if (queryFeedLoading || isLoading) return;
    onFeedResolved(flattenedAll.length > 0);
  }, [
    from,
    onFeedResolved,
    queryFeedLoading,
    isLoading,
    flattenedAll.length,
  ]);

  useEffect(() => {
    const checkEmptyStatus = async () => {
      if (!queryFeedLoading) {
        if (
          !queryFeed ||
          !queryFeed.resultArray ||
          queryFeed.resultArray.length === 0
        ) {
          if (!showEmptyInEditor) {
            await updateIsEmptyStatus(title, user_id, component.id,from);
          }
          setIsLoading(false);
        } else {
          setIsLoading(false);
          void handleFirstImage(
            title,
            component?.id,
            queryFeed.resultArray[0],
            user_id,
            from
          );
        }
      }
    };
    checkEmptyStatus();
  }, [queryFeedLoading, queryFeed]);

 



  return (
    <>
      {queryFeedLoading || isLoading ? (<StayFeedLoadingPlaceholder
          designTokens={designTokens}
          from={from}
          component={component}
          templateGridLoaderProps={templateGridLoaderProps}
        />) : RenderUI ? (
        shoppableFilteredAll.length === 0 ? (
          showEmptyInEditor ? (
            <FeedSectionEmptyState
            title={title}
            designTokens={designTokens}
            message={websiteEditorFeedEmptyMessage("keyword", {
              keywordPhrase: String(query || "").trim(),
            })}
          />
          ) : null
        ) : (
        <RenderUI
          data={shoppableFilteredAll}
          currentIndex={currentIndex}
          handleNavigate={handleNavigate}
          component={component}
          containerRef={containerRef}
          handleRedirect={handleRedirect}
          brand_color={brand_color}
          title={title}
          type={type}
          componentType={component?.type || type}
          isLinks={isLinks}
          from={from}
          username={username}
          user_id={user_id}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          designTokens={designTokens}
        />
        )
      )  : (queryFeed && !queryFeed.resultArray) ||
        queryFeed.resultArray.length === 0 ? (
        showEmptyInEditor ? (
          <FeedSectionEmptyState
            title={title}
            designTokens={designTokens}
            message={websiteEditorFeedEmptyMessage("keyword", {
              keywordPhrase: String(query || "").trim(),
            })}
          />
        ) : null
      ) : (
        <>
          {queryFeed && queryFeed.total_count > 0 ? (
            <PostTemplate
              processedData={queryFeed.resultArray}
              total_count={queryFeed.total_count}
              component={component}
              user_id={user_id}
              username={username}
              handleRedirect={handleRedirect}
              brand_color={brand_color}
              title={title}
              from={from}
              type={type}
              itemsPerPage={itemsPerPage}
              platform={type}
              pinnedPostIds={component?.pinned_posts?.split(",") || []}
              isLinks={isLinks}
              designTokens={designTokens}
            />
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default QueryLinkDataFront;
